import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
`;

export const UploadSectionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex: 0 0 auto;

`;

export const TableSection = styled.div`
  input {
    border: 1.6px solid var(--color-action-default, #2870b2) !important;
    box-shadow: none !important;
  }

  .react-datepicker-popper {
    z-index: 4;
  }
`;

export const TableCellText = styled.span`
  display: block;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10001;

  > div {
    z-index: 10001;
  }
`;
